import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Libraries components
import "./imports/bootstrap";
import "./imports/font-awesome";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
